/**
 * The poster's page drawn as a picture, the print alone (no frame : whoever shows it draws the
 * frame), by a ThumbGenerator of its own — the service one is shared with the save, which sends
 * what it draws as the creation's cover thumbnail.
 *
 *   shared.preview3d.PosterArtwork.render(owner, model, ratio) → Promise<data URL | null>
 *
 * owner : the component listening (fx events go through a listener, and stop with it) ; ratio :
 * pixels per millimetre of the page (5 → 1050 × 1500 for the 210 × 300 page). Null when the
 * generator is not in this bundle.
 */
fx.ns("shared.preview3d", class PosterArtwork {

    static render(owner, model, ratio)
    {
        return new Promise((resolve) => {
            let Generator = fx._services && fx._services.thumbgenerator;
            if (Generator && typeof Generator != "function")
                Generator = Generator.constructor;

            if (!Generator)
                return resolve(null);

            let generator = new Generator(model);
            generator.ratio = ratio || 2;
            generator.withFrame = false;

            let done = (e) => {
                owner.off("thumb-generated", done, generator);
                resolve(e.detail && e.detail.thumb || null);
            };
            owner.on("thumb-generated", done, generator);
            generator.generate(model.creation);
        });
    }
});
